"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const focus_trap_react_1 = require("focus-trap-react");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const molecules_1 = require("../../molecules");
// import { useBridge } from '@completeanatomy/bridge';
const licenses_1 = require("../../utils/licenses");
const i18n_1 = require("@completeanatomy/i18n");
const providers_1 = require("../../providers");
const react_transition_group_1 = require("react-transition-group");
function LicenseBuyCard({ license, rect, isOpen, showPrivacy = true, onClose, }) {
    // const bridge = useBridge();
    const inappStoreService = (0, providers_1.useInappStoreService)();
    const { t } = (0, i18n_1.useTranslation)();
    const onBuy = (0, react_1.useCallback)(() => {
        if (license === null || license === void 0 ? void 0 : license.product) {
            inappStoreService === null || inappStoreService === void 0 ? void 0 : inappStoreService.sendSubscriptionAddedToCartEvent(license === null || license === void 0 ? void 0 : license.product);
            // @ts-ignore
            window.Manager.InAppPurchaseManager.purchaseProductWithOptions({
                productIdentifier: license.product.identifier,
            });
            // bridge?.purchaseWithOptions({
            //   type: license.type,
            //   productID: license.product.identifier,
            // });
            onClose();
        }
    }, [inappStoreService, license.product, onClose]);
    const { x, y, width } = rect;
    const containerStyles = {
        top: `${y}px`,
        left: `${x}px`,
        width: `${width}px`,
    };
    const currentPrice = (0, licenses_1.currentPriceForLicense)(license).formattedValue;
    const regularPrice = (0, licenses_1.regularPriceForLicense)(license).formattedValue;
    const height = document.body.clientHeight - rect.y - 50;
    return ((0, jsx_runtime_1.jsx)(ui_1.ModalOverlay, { isOpen: isOpen, onClose: onClose, "data-e2e": 'LicenseBuyCard_ModalOverlay', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { addEndListener: (node, onEnd) => node.addEventListener('transitionend', onEnd), in: isOpen, appear: true, "data-e2e": 'LicenseBuyCard_CSSTransition', children: (0, jsx_runtime_1.jsx)(focus_trap_react_1.FocusTrap, { focusTrapOptions: { allowOutsideClick: true }, "data-e2e": 'LicenseBuyCard_FocusTrap', children: (0, jsx_runtime_1.jsxs)(Container, { style: containerStyles, "$isOpen": isOpen, "$height": height, "$maxHeight": document.body.clientHeight - y - 50, role: "alertdialog", "aria-modal": "true", "data-e2e": 'LicenseBuyCard_Container', children: [(0, jsx_runtime_1.jsx)(Cross, { onClick: onClose, "aria-label": t(i18n_1.Strings.common.close), "data-e2e": 'LicenseBuyCard_Cross' }), (0, jsx_runtime_1.jsx)(molecules_1.BuyLicenseButton, { isOpen: isOpen, license: license, onBuy: onBuy, "data-e2e": 'LicenseBuyCard_BuyLicenseButton' }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, addEndListener: (node, onEnd) => node.addEventListener('transitionend', onEnd), appear: true, "data-e2e": 'LicenseBuyCard_CSSTransition', children: (0, jsx_runtime_1.jsxs)(StyledScrollView, { "$isOpen": isOpen, "data-e2e": 'LicenseBuyCard_StyledScrollView', children: [(0, jsx_runtime_1.jsx)(Description, { "data-e2e": 'LicenseBuyCard_Description', children: (0, jsx_runtime_1.jsx)(molecules_1.PaymentDescription, { currentPrice: currentPrice, regularPrice: regularPrice, "data-e2e": 'LicenseBuyCard_PaymentDescription' }) }), showPrivacy && (0, jsx_runtime_1.jsx)(StyledPrivacyLinks, { "data-e2e": 'LicenseBuyCard_StyledPrivacyLinks' })] }) })] }) }) }) }));
}
exports.default = LicenseBuyCard;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 50px;
  left: 50%;

  display: flex;
  flex-direction: column;
  width: 210px;

  background-color: ${({ theme }) => theme.backgroundSenary};

  border-radius: 2px;

  box-shadow: ${({ theme }) => theme.store.buttonShadow};

  ${({ $height, $maxHeight, $isOpen }) => (0, styled_components_1.css) `
    max-height: ${$height}px;

    transition: max-height 0.3s ease-in-out;
    transition-delay: ${$isOpen ? '0.3s' : '0'};

    &.appear-active,
    &.enter-active,
    &.appear-done,
    &.enter-done {
      max-height: ${$maxHeight}px;
      height: unset;
    }

    &.exit-active {
      height: unset;
    }

    &.exit-active,
    &.exit-done {
      max-height: ${$height}px;
    }
  `}
`;
const Cross = (0, styled_components_1.default)(ui_1.CloseButton) `
  position: absolute;
  top: -20px;
  right: -20px;

  width: 16px;
  height: 16px;

  color: ${({ theme }) => theme.text};

  &:focus-visible {
    outline: ${({ theme }) => `2px solid ${theme.greenSecondary}`};
    outline-offset: 3px;
  }
`;
const Description = styled_components_1.default.div `
  margin: 20px 15px;

  color: ${({ theme }) => theme.text};

  font-size: 12px;

  text-align: left;
`;
const StyledPrivacyLinks = (0, styled_components_1.default)(ui_1.PrivacyLinks) `
  flex-shrink: 0;

  padding: 10px 15px;
`;
const StyledScrollView = (0, styled_components_1.default)(ui_1.SimpleScrollView) `
  flex-direction: column;
  flex-shrink: unset;

  width: 100%;

  transition: opacity 0.3s ease-in-out;
  transition-delay: ${({ $isOpen }) => ($isOpen ? '0.3s' : '0')};

  opacity: 0;

  &.enter,
  &.appear,
  &.exit,
  &.exit-active,
  &.exit-done {
    opacity: 0;
  }

  &.enter-active,
  &.appear-active,
  &.enter-done {
    opacity: 1;
  }
`;
